import angular from 'angular'

import deline from '../utils/deline'
import envRaw from '../utils/env-raw'

import { noop, last, flow, hasIn, assign, repeat, isArray, functions, isFunction, isPlainObject } from 'lodash-es'
import { getElmStrWithAttrs } from '../utils/get-elm-str'

const INFO_ATTRS = ['class', 'id', 'ng-if', 'roe-if', 'ggs-fast-switch', 'ggs-fast-switch-when']

const module = angular.module
angular.module = function DebugModule() {
  const debugModule = module.apply(angular, arguments)
  if (debugModule.__debug__) {
    return debugModule
  }

  const directive = debugModule.directive
  const component = debugModule.component
  debugModule.__debug__ = true
  if (envRaw.showsAngularComponentDebug) debugModule.component = debugComponent
  if (envRaw.showsAngularDirectiveDebug) debugModule.directive = debugDirective

  const methods = functions(debugModule)
  for (const method of methods) {
    debugModule[method] = flow(debugModule[method], returnDebugModule)
  }

  return debugModule

  function returnDebugModule() {
    return debugModule
  }

  function debugComponent(name, ddo) {
    const $inject = angular.injector.$$annotate(ddo.controller)
    const controller = isArray(ddo.controller) ? last(ddo.controller) : ddo.controller

    ddo.controller = debugController
    ddo.controller.$inject = ['$scope', '$element', '$attrs'].concat($inject)
    return component(name, ddo)

    function debugController($scope, $element, $attrs) {
      const condScope = $scope.$parent
      const depth = countDepth($scope)
      const elmStr = getElmStrWithAttrs($element, INFO_ATTRS)
      const condStr = getCondStr(condScope, $attrs)
      const postStr = getPostStr($scope)

      console.debug(deline(`[CMP] ${repeat('✈️ ', depth)} ${name} at ${elmStr} ${condStr} ${postStr}`))

      const $args = Array.prototype.slice.call(arguments, 3)
      const $ctrl = this
      $ctrl.constructor = controller
      controller.apply($ctrl, $args)
      return $ctrl
    }
  }

  function debugDirective(name, arg) {
    const $inject = angular.injector.$$annotate(arg)
    const provider = isArray(arg) ? last(arg) : arg

    debugProvider.$inject = $inject
    return directive(name, debugProvider)

    function debugProvider() {
      let pre = noop
      let post = noop
      const ddo = provider.apply(null, arguments)

      if (isFunction(ddo)) post = ddo
      if (isPlainObject(ddo) && isFunction(ddo.link)) post = ddo.link
      if (isPlainObject(ddo) && isPlainObject(ddo.link) && isFunction(ddo.link.pre)) pre = ddo.link.pre
      if (isPlainObject(ddo) && isPlainObject(ddo.link) && isFunction(ddo.link.post)) post = ddo.link.post

      const debugDDO = { link: { pre: debugPre, post } }
      return isFunction(ddo)
        ? debugDDO
        : assign(ddo, debugDDO)

      function debugPre(scope, elm, attr) {
        const condScope = ddo.scope ? scope.$parent : scope
        const depth = countDepth(scope)
        const elmStr = getElmStrWithAttrs(elm, INFO_ATTRS)
        const condStr = getCondStr(condScope, attr)
        const postStr = getPostStr(scope)

        console.debug(deline(`[DIR] ${repeat('→ ', depth)} ${name} at ${elmStr} ${condStr} ${postStr}`))
        return pre.apply(null, arguments)
      }
    }
  }

  function countDepth(scope) {
    let curr = scope
    let count = 0
    while (curr.$parent) {
      curr = curr.$parent
      count++
    }
    return count
  }

  function getCondStr(condScope, attr) {
    const arr = []
    if (attr.ngIf) arr.push(`ngIf=${condScope.$eval(attr.ngIf)}`)
    if (attr.roeIf) arr.push(`roeIf=${condScope.$eval(attr.roeIf)}`)
    if (attr.ggsFastSwitch) arr.push(`ggsFastSwitch=${condScope.$eval(attr.ggsFastSwitch)}`)
    return arr.length === 0 ? '' : `[${arr.join(', ')}]`
  }

  function getPostStr(scope) {
    if (hasIn(scope, '$ctrl.ggsPost.id')) {
      return `[id=${scope.$ctrl.ggsPost.id}]`
    } else if (hasIn(scope, '$ctrl.ggsPullElm.data.id')) {
      return `[id=${scope.$ctrl.ggsPullElm.data.id}]`
    } else {
      return ''
    }
  }
}
